export const getDominio = () => {
  return process.env.NODE_ENV == 'production'
    ? 'plataformadeseguros.com.br'
    : 'whitelabel.sulamerica.br';
};
